import { render, staticRenderFns } from "./PromoCompleted.vue?vue&type=template&id=2d86bec6&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d86bec6')) {
      api.createRecord('2d86bec6', component.options)
    } else {
      api.reload('2d86bec6', component.options)
    }
    module.hot.accept("./PromoCompleted.vue?vue&type=template&id=2d86bec6&", function () {
      api.rerender('2d86bec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Promo/view/PromoCompleted.vue"
export default component.exports